import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

export const engagementTemplatesAndMediaWebhookTemplatesTemplateIdNRO: NavigationRoutingObject = {
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("engagement-templates-and-media-webhook-templates-webhook-id-nro-heading", "Webhook Template"),
  pageNameForTracking: () => "Webhook Template",
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "engagement-templates-and-media-webhook-templates-webhook-id-nro-description",
      "View and edit webhook template"
    ),
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("webhook");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
